import { buildErrorsFromMsgs } from '../utils/errorHandling';
export const USER_NAME_FINISHED = "USER_NAME_FINISHED";
export const USER_NAME_CANCELED = "USER_NAME_CANCELED";
export const SEND_USER_NAME_DATA = 'SEND_USER_NAME_DATA';
export const CLEAR_USER_NAME_DATA = 'CLEAR_USER_NAME_DATA';
export const USER_NAME_ERROR = 'USER_NAME_ERROR';

/**
 * User name modal flow successfully created a loyalty user name
 */
export function userNameFinished() {
    return {
        type: USER_NAME_FINISHED
    };
}

/**
 * User name modal flow aborted
 */
export function userNameCanceled() {
    return {
        type: USER_NAME_CANCELED
    };
}

export function sendUserNameData(formData, msgs, previousMsgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);

    return {
        type: SEND_USER_NAME_DATA,
        payload: {
            data: formData,
            msgs: convertedMsgs
        }
    };
}

export function clearUserNameData() {
    return {
        type: CLEAR_USER_NAME_DATA,
        payload: {}
    };
}

export function userNameError(msgs) {
    return {
        type: USER_NAME_ERROR,
        error: true,
        payload: {
            msgs: msgs
        }
    };
}

